import { HttpClient } from '@angular/common/http';
import { Injectable, WritableSignal, signal } from '@angular/core';
import { Observable } from 'rxjs';
import { localStorageConstants } from './constants';
import { Apollo } from 'apollo-angular';
import { GET_USER_BY_AZURE_ID, SELF_PROVISION_USER } from '../graph-queries';
import { MutationResult, UpdateResult } from '../graph-queries/types';
import { User } from 'src/app/modules/users/models/user';

export type Profile = {
  displayName?: string;
  jobTitle?: string;
  mail?: string;
  officeLocation?: string;
  givenName?: string;
  surname?: string;
  userPrincipalName?: string;
  id?: string;
};

@Injectable({
  providedIn: 'root',
})
export class ProfileService {
  private readonly AZURE_GRAPHQL_URL: string =
    'https://graph.microsoft.com/v1.0/me';

  profile$: WritableSignal<Profile> = signal({});
  constructor(
    private http: HttpClient,
    private apolloClient: Apollo,
  ) {}

  getProfile(): Observable<Profile> {
    return this.http.get<Profile>(this.AZURE_GRAPHQL_URL);
  }

  selfProvisionUser(profile: Profile): Observable<MutationResult> {
    // AzureOid is passed as Id so the authorizer can verify it against the token.
    return this.apolloClient.mutate<UpdateResult>({
      mutation: SELF_PROVISION_USER,
      variables: {
        id: profile.id,
        payload: JSON.stringify({
          FirstName: profile.givenName,
          LastName: profile.surname,
          Email: profile.userPrincipalName,
          OfficeLocation: profile.officeLocation,
        }),
      },
    });
  }

  setFacilities(profile: Profile) {
    this.apolloClient
      .query({
        query: GET_USER_BY_AZURE_ID,
        variables: {
          id: profile.id,
        },
      })
      .subscribe((response: any) => {
        // Absent if provisioning has not landed yet; leave any prior value in place.
        const loggedInUser: User | null = response?.data?.GetUserByAzureId;
        if (!loggedInUser) {
          return;
        }
        localStorage.setItem(
          localStorageConstants.USER_FACILITIES_KEY,
          JSON.stringify(loggedInUser.FacilityAssignments),
        );
      });
  }
}
